import { NgClass, SlicePipe } from '@angular/common';
import { Component, Input, OnChanges, inject } from '@angular/core';

import { BetBuilderNoOfColumns, CrmPromoIdsMap, EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SourceOfPick } from '@frontend/sports/option/pick/feature/tracking';

import { BadgeComponent } from '../crm-promotion/badge.component';
import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionGroup, OptionGroupService } from './option-group.service';

@Component({
    selector: 'ms-bet-builder-teams-option-group',
    templateUrl: './bet-builder-teams-option-group.component.html',
    imports: [NgClass, SlicePipe, BadgeComponent, MarketHelpComponent, BetBuilderOptionComponent],
})
export class BetBuilderPlayerTeamOptionGroupComponent implements OnChanges {
    sitecore = inject(Sitecore);
    private optionGroupService = inject(OptionGroupService);

    @Input() event: EventModel;
    @Input() tracking: string;
    @Input() trackingModuleType = '';
    @Input() optionGroup: EventOptionGroup;
    @Input() showMarketHelp: boolean;
    @Input() crmPromoIdsMap: CrmPromoIdsMap;
    @Input() eventHelpText?: string;
    @Input() sourceOfPick = SourceOfPick.Other;

    optionGroups: OptionGroup[];

    expanded = false;
    showMoreLessButtonVisible = false;
    visibleOptionsLimit: number | undefined;

    isSingleRowOfOptions = () => this.optionGroup.options.length === BetBuilderNoOfColumns.Triple;

    ngOnChanges(): void {
        this.optionGroups = this.optionGroupService.getOptionGroups(this.optionGroup, (option) => option.marketAttribute);
    }

    trackOption(index: number, option: EventOption): number {
        return option.id;
    }

    trackGroup(index: number, group: OptionGroup): string {
        return group.attribute || '';
    }

    isMarketPromoted(optionGroupId: number, templateId?: number): boolean {
        return !!this.crmPromoIdsMap.markets[optionGroupId] || (templateId != undefined && !!this.crmPromoIdsMap.templateIds[templateId]);
    }
}
